import React from 'react';
import {Banner, Button, Dialogue, Text, Icon} from '@albert-io/atomic';
import HardCapWarningBanner from 'client/components/HardCapWarningBanner/HardCapWarningBanner.react';

import '../invite-by-email.scss';

interface Props {
  handleClose?: () => void;
  onBackBtnClick?: () => void;
  rejectedInvitations: string[];
  fulfilledInvitations: string[];
  hardCapRejectedInvitations: string[];
  className?: string;
  inModal?: boolean;
  size?: 'full' | 'xl' | 'l' | 'm' | 's';
  hideCloseBtn?: false;
}

const IBESummary = ({
  handleClose,
  onBackBtnClick,
  rejectedInvitations,
  hardCapRejectedInvitations,
  fulfilledInvitations,
  ...rest
}: Props) => {
  return (
    <Dialogue handleClose={handleClose} title='Confirmation' {...rest}>
      <Dialogue.Body>
        {fulfilledInvitations.length !== 0 && (
          <div className='gap-x1 p-x2 flex flex-col overflow-y-auto'>
            {fulfilledInvitations.map((email) => (
              <div key={email} className='flex w-full justify-between'>
                <Text className='overflow-hidden text-left text-ellipsis whitespace-nowrap'>
                  {email}
                </Text>
                <div className='ibe-center-padding mx-x1' />
                <div className='flex items-center'>
                  <Text className='mr-x1 content-positive whitespace-nowrap'>Invited</Text>
                  <Icon icon='check' color='inherit' className='content-positive' />
                </div>
              </div>
            ))}
          </div>
        )}
        {hardCapRejectedInvitations.length !== 0 && (
          <>
            <HardCapWarningBanner seatsRemaining={0} rounded className='my-x1' />
            <div className='gap-x1 p-x2 flex flex-col overflow-y-auto'>
              {hardCapRejectedInvitations.map((email) => (
                <div key={email} className='flex w-full justify-between'>
                  <Text className='overflow-hidden text-left text-ellipsis whitespace-nowrap'>
                    {email}
                  </Text>
                  <div className='ibe-center-padding mx-x1' />
                  <div className='flex items-center'>
                    <Text color='negative' className='mr-x1 whitespace-nowrap'>
                      Not invited
                    </Text>
                    <Icon icon='xmark' color='inherit' className='content-negative' />
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {rejectedInvitations.length !== 0 && (
          <>
            <Banner type='negative' className='mb-x2' dismissable={false} border={false}>
              We encountered a problem sending invitations to the following recipients. Please try
              again:
            </Banner>
            <div className='gap-x1 p-x2 flex flex-col overflow-y-auto'>
              {rejectedInvitations.map((email) => (
                <div key={email} className='flex w-full justify-between'>
                  <Text className='overflow-hidden text-left text-ellipsis whitespace-nowrap'>
                    {email}
                  </Text>
                  <div className='ibe-center-padding mx-x1' />
                  <div className='flex items-center'>
                    <Text color='negative' className='mr-x1 whitespace-nowrap'>
                      Not invited
                    </Text>
                    <Icon icon='xmark' color='inherit' className='content-negative' />
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </Dialogue.Body>
      <Dialogue.BtnGroup>
        <Button color='secondary' onClick={onBackBtnClick}>
          Back
        </Button>
        <Button onClick={handleClose}>Finish</Button>
      </Dialogue.BtnGroup>
    </Dialogue>
  );
};

export default IBESummary;
